import Vue from "vue";

export async function fetchProtagonists({ commit }, full_legal_number, type) {
  try {
    const { data } = await Vue.axios({
      method: "GET",
      url: `/frontend/protagonists`,
      params: { type }
    })

    return data
  } catch (error) {} finally {}
}

export async function fetchProtagonistLink({ commit }, type) {
  try {
    const { data } = await Vue.axios({
      method: "GET",
      url: `/frontend/protagonists/protagonist_link`,
      params: { type }
    })

    return data
  } catch (error) {
    return { success: false, message: 'Error' }
  } finally {}
}

export async function fetchProtagonistsHome({ commit }) {
  try {
    const { data } = await Vue.axios({
      url: `/frontend/protagonists_home`
    });
    commit("setProtagonistsHome", data);
  } catch (e) {
    console.log(e);
  } finally {
    // console.log("La petición para obtener el post ha finalizado");
  }
}